import { getUnusualEvents } from '../../api/unusual';
import { getAnalytics } from '../../api/analytics';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_IDENTICAL_MARKERS_VALUE = 'CHANGE_IDENTICAL_MARKERS_VALUE';
export const CHANGE_IDENTICAL_MARKERS_SEVERAL_VALUES = 'CHANGE_IDENTICAL_MARKERS_SEVERAL_VALUES';
export const CHANGE_IDENTICAL_MARKERS_CURRENT_IMAGE = 'CHANGE_IDENTICAL_MARKERS_CURRENT_IMAGE';
export const SET_IDENTICAL_MARKERS_EVENT_IMAGE = 'SET_IDENTICAL_MARKERS_EVENT_IMAGE';
export const RESET_IDENTICAL_MARKERS_STORE = 'RESET_IDENTICAL_MARKERS_STORE';

export const GET_IDENTICAL_MARKERS = 'GET_IDENTICAL_MARKERS';
export const GET_IDENTICAL_MARKERS_SUCCESS = 'GET_IDENTICAL_MARKERS_SUCCESS';
export const GET_IDENTICAL_MARKERS_ERROR = 'GET_IDENTICAL_MARKERS_ERROR';

export const GET_IDENTICAL_MARKERS_ANALYTIC = 'GET_IDENTICAL_MARKERS_ANALYTIC';
export const GET_IDENTICAL_MARKERS_ANALYTIC_SUCCESS = 'GET_IDENTICAL_MARKERS_ANALYTIC_SUCCESS';
export const GET_IDENTICAL_MARKERS_ANALYTIC_ERROR = 'GET_IDENTICAL_MARKERS_ANALYTIC_ERROR';

export const getIdenticalMarkersAction = (function () {
  let prevController;

  return (params, actions = {}) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_IDENTICAL_MARKERS });
      try {
        const response = await getUnusualEvents(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_IDENTICAL_MARKERS_SUCCESS, payload: results, params });
          actions.onSuccess && actions.onSuccess(results.content);
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_IDENTICAL_MARKERS_ERROR });
          actions.onError && actions.onError(error.message);
        }
      }
    };
  };
})();

export const getIdenticalMarkersAnalyticAction = (function () {
  let prevController;

  return (params) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_IDENTICAL_MARKERS_ANALYTIC });
      try {
        const response = await getAnalytics(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_IDENTICAL_MARKERS_ANALYTIC_SUCCESS, payload: results, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_IDENTICAL_MARKERS_ANALYTIC_ERROR });
        }
      }
    };
  };
})();

export const changeValue = (key, value) => ({
  type: CHANGE_IDENTICAL_MARKERS_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_IDENTICAL_MARKERS_SEVERAL_VALUES,
  payload: value,
});

export const changeCurrentImage = (index, value) => ({
  type: CHANGE_IDENTICAL_MARKERS_CURRENT_IMAGE,
  payload: { index, value },
});

export const setEventImage = (eventId, index, image) => ({
  type: SET_IDENTICAL_MARKERS_EVENT_IMAGE,
  payload: { eventId, index, image },
});

export const resetStore = () => ({
  type: RESET_IDENTICAL_MARKERS_STORE,
});
